import { render } from "./panel-empty-state.vue?vue&type=template&id=0c31ca36&scoped=true&ts=true"
import script from "./panel-empty-state.vue?vue&type=script&lang=ts"
export * from "./panel-empty-state.vue?vue&type=script&lang=ts"

import "./panel-empty-state.vue?vue&type=style&index=0&id=0c31ca36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c31ca36"]])

export default __exports__